import axios from 'axios';
import { accsiomURIs, mrcPort } from 'src/config';

export const getGasFee = async (record) => {
  const res = await axios.get(`${accsiomURIs.bs_uri}:${mrcPort}/estimate_gas_fee`, {
    params: record
  });
  return res.data.data.gasLimit;
};
